"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Tooltip/HoverTooltip.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);






var _common = require('web/components/Tooltip/common');
var _ClickTooltip = require('web/components/Tooltip/ClickTooltip'); var _ClickTooltip2 = _interopRequireDefault(_ClickTooltip);

var _responsive = require('web/services/responsive');







const createInitialState = () => ({
  open: false,
  tooltipPosition: {},
  tooltipArrowPosition: {},
})







// The inner tooltip never had defaultProps (only the function wrapper did, and
// React 19 ignores those), so no prop gets a default here either.
const HoverTooltip = _react2.default.memo((props) => {
  const { children, content, className, hideArrow, type, place } = props
  const [state, setState] = _react.useState.call(void 0, createInitialState)
  const { open, tooltipPosition, tooltipArrowPosition } = state

  const { childRefs, cloneChildrenWithRefs } = _common.useChildRefs.call(void 0, )
  const targetRef = _react.useRef(null)
  const tooltipRef = _react.useRef(null)

  // The native listeners run after later renders; like the class reading
  // this.props, they read the latest committed props.
  const propsRef = _react.useRef.call(void 0, props)
  _react.useLayoutEffect.call(void 0, () => {
    propsRef.current = props
  })

  // setState callbacks: the class passed onOpen/onClose to setState, which
  // calls them once the update is committed. Queue them for the commit.
  // They run at this component's next commit; that is always the queued
  // update's own commit unless a higher-priority render commits first, a gap
  // no caller depends on (none passes onOpen/onClose today).
  const pendingCallbacksRef = _react.useRef([])
  _react.useLayoutEffect.call(void 0, () => {
    const callbacks = pendingCallbacksRef.current
    if (!callbacks.length) return
    pendingCallbacksRef.current = []
    callbacks.forEach(callback => _optionalChain([callback, 'optionalCall', _ => _()]))
  })

  const showTooltip = _react.useCallback.call(void 0, (key) => {
    const latest = propsRef.current
    // SAFETY: every caller passes `place`; the class made the same assumption.
    const tooltipPlace = latest.place 

    const nextTooltipPosition = latest.fixedPosition || _common.getTooltipPosition.call(void 0, 
      childRefs.current[key],
      tooltipRef.current,
      tooltipPlace,
      latest.hideArrow,
      latest.offset,
    )

    const nextTooltipArrowPosition = _common.getToolTipArrowPosition.call(void 0, 
      // SAFETY: the container is mounted while its children's listeners are.
      targetRef.current ,
      nextTooltipPosition,
      tooltipPlace,
    )

    pendingCallbacksRef.current.push(latest.onOpen)
    setState({
      open: true,
      tooltipPosition: nextTooltipPosition,
      tooltipArrowPosition: nextTooltipArrowPosition,
    })
  }, [childRefs])

  const hideTooltip = _react.useCallback.call(void 0, () => {
    pendingCallbacksRef.current.push(propsRef.current.onClose)
    setState(s => ({ ...s, open: false, tooltipPosition: {} }))
  }, [])

  // componentDidUpdate: a new `place` hides the tooltip.
  const prevPlaceRef = _react.useRef.call(void 0, place)
  _react.useLayoutEffect.call(void 0, () => {
    if (prevPlaceRef.current === place) return
    prevPlaceRef.current = place
    hideTooltip()
  }, [place, hideTooltip])

  _react.useLayoutEffect.call(void 0, () => {
    // Listeners go on the children present at mount, as componentDidMount
    // did; the cleanup reads the refs at unmount, as componentWillUnmount did.
    const refs = childRefs.current
    const mouseEnterEventHandlers = {}
    const mouseLeaveEventHandlers = {}
    const showOnFocus = !!propsRef.current.showOnFocus
    Object.keys(refs).forEach(key => {
      mouseEnterEventHandlers[key] = () => showTooltip(key)
      mouseLeaveEventHandlers[key] = () => hideTooltip()
      _optionalChain([refs, 'access', _2 => _2[key], 'optionalAccess', _3 => _3.addEventListener, 'call', _4 => _4('mouseenter', mouseEnterEventHandlers[key])])
      _optionalChain([refs, 'access', _5 => _5[key], 'optionalAccess', _6 => _6.addEventListener, 'call', _7 => _7('mouseleave', mouseLeaveEventHandlers[key])])
      if (showOnFocus) {
        _optionalChain([refs, 'access', _8 => _8[key], 'optionalAccess', _9 => _9.addEventListener, 'call', _10 => _10('focusin', mouseEnterEventHandlers[key])])
        _optionalChain([refs, 'access', _11 => _11[key], 'optionalAccess', _12 => _12.addEventListener, 'call', _13 => _13('focusout', mouseLeaveEventHandlers[key])])
      }
    })

    return () => {
      Object.keys(refs).forEach(key => {
        const onEnter = mouseEnterEventHandlers[key]
        const onLeave = mouseLeaveEventHandlers[key]
        if (onEnter) _optionalChain([refs, 'access', _14 => _14[key], 'optionalAccess', _15 => _15.removeEventListener, 'call', _16 => _16('mouseenter', onEnter)])
        if (onLeave) _optionalChain([refs, 'access', _17 => _17[key], 'optionalAccess', _18 => _18.removeEventListener, 'call', _19 => _19('mouseleave', onLeave)])
        if (onEnter) _optionalChain([refs, 'access', _20 => _20[key], 'optionalAccess', _21 => _21.removeEventListener, 'call', _22 => _22('focusin', onEnter)])
        if (onLeave) _optionalChain([refs, 'access', _23 => _23[key], 'optionalAccess', _24 => _24.removeEventListener, 'call', _25 => _25('focusout', onLeave)])
      })
    }
    // Runs on mount/unmount only: every dependency is stable, and the
    // handlers read the latest props through a ref.
  }, [childRefs, showTooltip, hideTooltip])

  const tooltipClassName = _classBuilder2.default.call(void 0, 
    'blm-tooltip',
    'blm-tooltip--hover',
    _common.getTooltipTypeClass.call(void 0, { type, place }),
    { hidden: !open },
  )

  const containerClassName = _classBuilder2.default.call(void 0, 
    'blm-tooltip--container', className,
  )

  return (
    _react2.default.createElement('div', { className: containerClassName, ref: targetRef, __self: this, __source: {fileName: _jsxFileName, lineNumber: 148}}
      , cloneChildrenWithRefs(children)
      , _react2.default.createElement('div', {
        className: tooltipClassName,
        style: tooltipPosition,
        ref: tooltipRef, __self: this, __source: {fileName: _jsxFileName, lineNumber: 150}}

        ,  hideArrow
          ? null
          : _react2.default.createElement('div', { className: "blm-tooltip--arrow", style: tooltipArrowPosition, __self: this, __source: {fileName: _jsxFileName, lineNumber: 157}})
        
        , content
      )
    )
  )
})
HoverTooltip.displayName = 'HoverTooltip'





const HoverTooltipWrapper = ({
  children, mobileShow = false, ...props
}) => (
  window.innerWidth > _responsive.MobileWidth
    ? _react2.default.createElement(HoverTooltip, { ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 174}}, children)
    : mobileShow
      ? _react2.default.createElement(_ClickTooltip2.default, { ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 176}}, children)
      : children
)

exports. default = HoverTooltipWrapper
